import { IAnalyticsData } from '../components/Analytics/Analytics'

import axiosAuth from './axiosAuth'

export const getAnalytics = (controller: AbortController, params: string) =>
    axiosAuth.get<Record<string, IAnalyticsData>>(
        `/conversation_stats${params ? '?' + params : ''}`,
        {
            signal: controller.signal,
        }
    )
